export enum ProfileActionTypes {
  SET_STATE = 'PROFILE.SET_STATE',
  GET_PROFILE = 'PROFILE.GET_PROFILE',
  GET_KYC_LINK = 'PROFILE.GET_KYC_LINK',
  GET_BALANCE = 'PROFILE.GET_BALANCE',
  BUY_RPV_TOKENS = 'PROFILE.BUY_RPV_TOKENS',
  GET_RATE = 'PROFILE.GET_RATE',
  GET_FEE = 'PROFILE.GET_FEE',
}
